export default __webpack_public_path__ + "static/media/logo-the-house-club.12677453.png";